import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetPolicyDetailDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;
}
